export type WorkspaceAgentClipLookupCoverage = {
  /** Ids a successful `Clips.listByIds` already asked for. Absent until one has succeeded. */
  coveredClipIds: ReadonlySet<string> | undefined;
  isError: boolean;
};

/**
 * A failed lookup leaves an id unresolved only when no successful response has covered it.
 * An id that successful response omitted is confirmed missing, not unresolved.
 */
export const isWorkspaceAgentClipLookupUnresolved = (
  clipId: string,
  { coveredClipIds, isError }: WorkspaceAgentClipLookupCoverage,
): boolean => {
  if (!isError) {
    return false;
  }

  if (!coveredClipIds) {
    return true;
  }

  return !coveredClipIds.has(clipId);
};
